module.exports = __webpack_public_path__ + "img/talk_5.4970c061.png";